import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67456d08"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67456d08')) {
      api.createRecord('67456d08', component.options)
    } else {
      api.reload('67456d08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67456d08", function () {
      api.rerender('67456d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/atmosphere/index.vue"
export default component.exports